import React from "react";

//const debugPageName = "User Data"
//withRouter

// This will be used as a test to see if another loading mechanism works
class UserData extends React.Component {
	
	constructor(props) {
        super(props);
        this.state = {
			currentUser: "Nope",
		};
	}
	
	componentDidMount = () => {
		
	}
	
	checkWholeState = () => {
		console.log("...This is the currently loaded API stuff...")
		//console.log(this.state.currentUser)
		console.log("...END...")
	}
	
	render() {
		
		return (
			<div className="userDataHolder">
			
			</div>
		)
	}
}

export default UserData;